import ActivityManager from "@/activity/ActivityManager";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";

/**
 @@action {
    name: "Show list of sticky notes"
    patterns: "Show sticky notes", "Sticky notes", "Show list of sticky notes"
     icon: "sticky-note"
  }

 @@action{
   name: "Remove sticky note"
   patterns: "Remove sticky note", "Delete sticky note"
  icon: "sticky-note"
 }

 @@action{
   name: "Edit sticky note"
   patterns: "Edit sticky note"
   icon: "sticky-note"
 }

 @returns {Promise<void>}
 */
export async function showListOfStickyNotes(){
    await EventBus.$emit(Events.showOrHideStickyNotesList);
}

/**
@@action{
   name: "Add sticky note"
   patterns: "Add sticky note", "New sticky note"
  icon: "sparkles"
 }

@returns {Promise<void>}
*/
export async function addStickyNote(){
    await Rpc.StickyNotes.addPinnedStickyNote(window.innerWidth - 305, 190)
}
